import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"max-width":"390"},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c(VCard,[_c(VCardTitle,{staticClass:"v-card__title headline"},[_vm._v(_vm._s(_vm.$t(this.$props.message)))]),_c(VCardActions,[_c(VSpacer),_c(VBtn,{attrs:{"color":"error darken-1"},on:{"click":function($event){_vm.showDialog = false;}}},[_vm._v(_vm._s(_vm.$t(this.$props.cancel)))]),_c(VBtn,{attrs:{"color":"success darken-1"},on:{"click":_vm.confirmClick}},[_vm._v(_vm._s(_vm.$t(this.$props.confirm)))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }